import { Box, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { FC, ReactElement } from "react";

const color = 'rgba(0, 0, 0, 0.54)'

const useStyles = makeStyles((theme) => ({
    outlineDiv: {
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: color
            },
            '&:hover fieldset': {
                borderColor: color
            }
        },
        width: "100%"
    }
}));

const InputComponent = (other: any) => <div {...other} />

interface IProps {
    label: string
    children: ReactElement
}

const OutlinedDiv: FC<IProps> = ({ children, label }) => {
    const classes = useStyles()

    return (
        <Box>
            <br />
            <TextField
                className={classes.outlineDiv}
                variant="outlined"
                label={label}
                multiline
                InputLabelProps={{ shrink: true }}
                InputProps={{
                    inputComponent: InputComponent
                }}
                inputProps={{ children: children }}
            />
            <br />
        </Box>
    )
}

export default OutlinedDiv